import type { BrandConfigInput } from "@cfg/brand-sdk";

/**
 * BrickBrackets: "The Maker's Ledger". Warm graph paper, ink navy text,
 * one blueprint-blue accent, handwriting display over monospace working type.
 * Serializable: this object becomes brand.json at deploy.
 */
export const config: BrandConfigInput = {
  id: "brickbrackets",
  name: "BrickBrackets",
  tagline: "Parametric display brackets for LEGO sets, generated in your browser.",
  domain: "brickbrackets.io",
  locale: "en",
  scene: "ledger",
  packs: ["brickbrackets@^1"],
  catalog: { include: ["brickbrackets.*"] },
  features: { betaChannel: false, fitTags: true, publicGallery: true },
  fitTags: {
    label: "LEGO® set",
    refPattern: "^\\d{3,7}(-\\d{1,2})?$",
    refPlaceholder: "Set number, e.g. 42115-1",
    namePlaceholder: "Set name (optional)",
    disclaimer: "LEGO® is a trademark of the LEGO Group, which does not sponsor, authorize or endorse this site.",
  },
  copy: {
    "community.title": "Community brackets",
    "community.sub": "Dimensions other builders printed, tagged by the set they fit.",
    "community.search": "Set number",
    "fits.printed": "I've printed this and it fits my set",
    "nav.catalog": "Brackets",
    "nav.mine": "My brackets",
    "catalog.title": "Pick a bracket",
    "configurator.params": "Dimensions",
    "configurator.warnings": "Print check",
    "footer.madeWith": "Every millimetre is computed in your browser. Nothing leaves your machine until you press Save.",
  },
  theme: {
    colors: {
      bg: "#f7f4ec",
      surface: "#fbf9f3",
      surfaceRaised: "#fbf9f3",
      text: "#2b3a55",
      textMuted: "#6b6b66",
      accent: "#3b6ea5",
      accentContrast: "#fbf9f3",
      accentSoft: "rgba(59,110,165,0.12)",
      border: "#d8e0e8",
      borderStrong: "#c3cfdc",
      danger: "#c0392b",
      success: "#2e7d32",
      model: "#d7353b",
      stage: "#f2eee1",
    },
    fonts: {
      display: '"Architects Daughter", "Comic Sans MS", cursive',
      body: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
      mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
    },
    webFonts: ["Architects Daughter", "JetBrains Mono:wght@400;600;800"],
    radius: { sm: "3px", md: "4px", lg: "6px", pill: "999px" },
    spacing: { unit: 4 },
    type: { baseSize: "13px", ratio: 1.2, labelTracking: "0.1em" },
    shadows: {
      sm: "2px 2px 0 #2b3a55",
      md: "3px 3px 0 #2b3a55",
      lg: "4px 4px 0 #2b3a55",
    },
    extras: {
      gridLine: "#d8e0e8",
      gridStrong: "#c3cfdc",
      tape: "rgba(212,199,158,0.55)",
    },
  },
};
